import React from "react";
import { useTranslation } from "react-i18next";
import { genresData } from "../../../constants/structure";
import styles from "./RoomGenreFilter.module.scss";
import CloseModalOpacity from "../../../components/icons/profile/closeModalOpacity";

interface RoomGenreFilterProps {
  selectedGenreIds: number[];
  onToggleGenre: (id: number) => void;
  onApply: () => void;
  onClose: () => void;
  isOpen: boolean;
}

const RoomGenreFilter: React.FC<RoomGenreFilterProps> = ({
  selectedGenreIds,
  onToggleGenre,
  onApply,
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
        <div
          className={styles.closeIconWrapper}
          onClick={onClose}
        ><CloseModalOpacity />
        </div>
        <h3 className={styles.title}>{t("genre", "Genre")}</h3>
        <div className={styles.genreGrid}>
          {genresData.map((genre) => (
            <button
              key={genre.id}
              className={`${styles.genreChip} ${
                selectedGenreIds.includes(genre.id) ? styles.genreChipActive : ""
              }`}
              onClick={() => onToggleGenre(genre.id)}
            >
              {t(genre.name)}
            </button>
          ))}
        </div>
        <button className={styles.applyBtn} onClick={onApply}>
          {t("room_apply_filters", "Apply")}
        </button>
      </div>
    </div>
  );
};

export default RoomGenreFilter;
